import {
  flagValuationForUpdate,
  setValuationHomeFactsProgress,
} from '../../../../actions/valuation'
import Steps from './Steps'
import Wizard from '../../../shared/Wizard'
import { useDispatch, useSelector } from 'react-redux'
import { addHomeAnswer } from '../../../../actions/home'
import { selectHomeData } from '../../../../store/selectors/home'

const STEPS = {
  HOME_FACTS_BEDS: 'HOME_FACTS_BEDS',
  HOME_FACTS_BATHS: 'HOME_FACTS_BATHS',
  HOME_FACTS_SQFT: 'HOME_FACTS_SQFT',
  HOME_FACTS_ADDITIONAL_UPDATES: 'HOME_FACTS_ADDITIONAL_UPDATES',
}

const HomeFactsWizard = ({ setProgress }) => {
  const dispatch = useDispatch()
  const home = useSelector(selectHomeData)

  const handleAddHomeAnswer = answerData => {
    dispatch(addHomeAnswer(answerData))
    dispatch(flagValuationForUpdate())
  }

  return (
    <Wizard provider initialStep={STEPS.HOME_FACTS_BEDS}>
      <Wizard step={STEPS.HOME_FACTS_BEDS}>
        <Steps.EnterBeds
          defaultBeds={home.bedrooms}
          addHomeAnswer={handleAddHomeAnswer}
          setProgress={setProgress}
        />
      </Wizard>
      <Wizard step={STEPS.HOME_FACTS_BATHS}>
        <Steps.EnterBaths
          defaultBaths={home.bathrooms}
          addHomeAnswer={handleAddHomeAnswer}
          setProgress={setProgress}
        />
      </Wizard>
      <Wizard step={STEPS.HOME_FACTS_SQFT}>
        <Steps.EnterSqFt
          defaultSqFt={home.finishedSqFt}
          addHomeAnswer={handleAddHomeAnswer}
          setProgress={setProgress}
        />
      </Wizard>
      <Wizard step={STEPS.HOME_FACTS_ADDITIONAL_UPDATES}>
        <Steps.EnterAdditionalUpdates
          addHomeAnswer={handleAddHomeAnswer}
          setProgress={setProgress}
        />
      </Wizard>
    </Wizard>
  )
}

const HomeFacts = () => {
  const dispatch = useDispatch()
  const setProgress = progress => {
    dispatch(setValuationHomeFactsProgress(progress))
  }

  return <HomeFactsWizard setProgress={setProgress} />
}

export default HomeFacts
